import axios from "axios";

export const relatedProductData = (id) => {
  return axios
    .get(`/related_products/${id}`)
    .then((response) => {
    //   console.log(response.data.data);
      return response;
    });
};